(() => {
  if (customElements.get('pnp-product-addon')) return;
  class PnpProductAddon extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      try { this.config = JSON.parse(this.querySelector('[data-addon-config]').textContent); }
      catch (_) { return; }
      this.form = document.getElementById(this.config.formId);
      this.scope = this.closest('.product__info-container');
      this.picker = this.scope?.querySelector('variant-selects, variant-radios');
      if (!this.form || !this.picker) return;
      this.groups = Array.from(this.picker.querySelectorAll('.product-form__input'));
      this.legacyGroup = this.groups[this.config.legacyIndex];
      if (!this.legacyGroup) return;
      this.initialized = true;
      this.onFormData = event => this.rewriteFormData(event.formData);
      this.form.addEventListener('formdata', this.onFormData);
      this.legacyGroup.hidden = true;
      const ready = [customElements.whenDefined(this.picker.localName)];
      if (this.scope.closest('.shopify-section')?.querySelector('media-gallery')) ready.push(customElements.whenDefined('media-gallery'));
      Promise.all(ready).then(() => {
        if (!this.isConnected) return;
        const controls = Array.from(this.legacyGroup.querySelectorAll('input[type="radio"], select'));
        const control = controls.find(input => input.tagName === 'SELECT' || input.value === this.config.baseOption);
        if (control && (control.tagName === 'SELECT' ? control.value !== this.config.baseOption : !control.checked)) {
          if (control.tagName === 'SELECT') control.value = this.config.baseOption;
          else control.checked = true;
          control.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
    disconnectedCallback() {
      this.form?.removeEventListener('formdata', this.onFormData);
      this.initialized = false;
    }
    selectedVariant() {
      const options = this.groups.map((group, index) => {
        if (index === this.config.legacyIndex) return this.config.baseOption;
        return group.querySelector('select')?.value || group.querySelector('input[type="radio"]:checked')?.value;
      });
      return this.config.variants.find(variant => variant.options.every((value, index) => value === options[index]));
    }
    hasAddon() {
      return this.config.addonAvailable && this.querySelector('input[value="add"]')?.checked;
    }
    quantity() {
      return Math.max(1, Number(this.form.querySelector('[name="quantity"]')?.value || this.scope.querySelector('[name="quantity"]')?.value || 1));
    }
    rewriteFormData(data) {
      const variant = this.selectedVariant();
      if (!variant) return;
      const entries = Array.from(data.entries());
      const parentIds = new Set(this.config.variants.map(item => String(item.id)));
      const existing = entries.filter(([name]) => /^items\[\d+\]\[id\]$/.test(name));
      const mainItems = existing.filter(([, id]) => parentIds.has(String(id)));
      let nextIndex = existing.reduce((max, [name]) => Math.max(max, Number(name.match(/^items\[(\d+)\]/)[1]) + 1), 0);
      let addonQuantity = 0;
      for (const [name] of mainItems) {
        data.set(name, String(variant.id));
        const prefix = name.replace(/\[id\]$/, '');
        addonQuantity += Math.max(1, Number(data.get(`${prefix}[quantity]`) || 1));
      }
      if (!this.hasAddon()) {
        if (data.has('id')) data.set('id', String(variant.id));
        return;
      }
      if (!mainItems.length) {
        const prefix = `items[${nextIndex++}]`;
        data.set(`${prefix}[id]`, String(variant.id));
        addonQuantity = Math.max(1, Number(data.get('quantity') || this.quantity()));
        data.set(`${prefix}[quantity]`, String(addonQuantity));
        for (const [name, value] of entries) {
          if (name === 'selling_plan' || /^properties\[.+\]$/.test(name)) {
            const nestedName = name === 'selling_plan' ? '[selling_plan]' : `[properties]${name.slice('properties'.length)}`;
            data.append(prefix + nestedName, value);
          }
        }
      }
      for (const [name] of entries) {
        if (name === 'id' || name === 'quantity' || name === 'selling_plan' || /^properties\[.+\]$/.test(name)) data.delete(name);
      }
      const prefix = `items[${nextIndex}]`;
      data.set(`${prefix}[id]`, String(this.config.addonId));
      data.set(`${prefix}[quantity]`, String(addonQuantity));
    }
  }
  customElements.define('pnp-product-addon', PnpProductAddon);
})();
